<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header" v-if="!modal" >Información del Equipo</div>
          <b-form>
            <b-form-group
              label="Código"
              label-for="codigo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigo"
                v-model.trim="$v.codigo.$model" 
                :state="codigoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="codigoFeedback">
                {{ codigoInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Marca/Modelo"
              label-for="marcaModelo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="marcaModelo"
                v-model.trim="$v.marcaModelo.$model" 
                :state="marcaModeloValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="marcaModeloFeedback">
                {{ marcaModeloInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Nro.Serie"
              label-for="numeroSerie"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroSerie"
                v-model.trim="$v.numeroSerie.$model" 
                :state="numeroSerieValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroSerieFeedback">
                {{ numeroSerieInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Características"
              label-for="caracteristicas"
              :labelCols="labelCols"
              horizontal>
              <b-form-textarea
                id="caracteristicas"
                v-model="$v.caracteristicas.$model" 
                rows="5"
                :state="caracteristicasValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="caracteristicasFeedback">
                {{ caracteristicasInvalidasMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <app-rubro
              label="Rubro"
              :nombre="rubroNombre"
              :labelCols="labelCols"
              :valido="rubroValido"
              :lista="rubrosList"
              :msjInvalido="rubroInvalidoMsj"
              @validate="validate"
              @updated="rubroActualizado">
            </app-rubro>
            
           <b-form-group
              label="Cotización"
              label-for="cotizacion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cotizacion"
                v-model.trim="$v.cotizacion.$model" 
                :state="cotizacionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cotizacionFeedback">
                {{ cotizacionInvalidaMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Pje.Amortización"
              label-for="pjeAmortizacion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pjeAmortizacion"
                v-model.trim="$v.pjeAmortizacion.$model" 
                :state="pjeAmortizacionValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeAmortizacionFeedback">
                {{ pjeAmortizacionInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="enRevision"
                  v-model="enRevision"
                  value= true
                  unchecked-value= false>
                  En Revisión
              </b-form-checkbox>
            </b-form-group>
          </b-form>

          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      v-if= "!modal"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Rubro from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, decimal, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'computadora/getField',
  mutationType: 'computadora/updateField',
});

export default {
  name: 'ComputadoraABM',
  components: {
    appRubro: Rubro,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    bienId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noValidar: true,
      codigoValido: null,
      codigoInvalidoMsj: '',
      marcaModeloValido: null,
      marcaModeloInvalidoMsj: '',
      numeroSerieValido: null,
      numeroSerieInvalidoMsj: '',
      caracteristicasValidas: null,
      caracteristicasInvalidasMsj: '',
      rubroValido: null,
      rubroInvalidoMsj: '',
      cotizacionValida: null,
      cotizacionInvalidaMsj: '',
      pjeAmortizacionValido: null,
      pjeAmortizacionInvalidoMsj: '',

      rubros: [],
      rubrosList: [],

      labelCols: 2,
      inicializando: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'codigo',
      'marcaModelo',
      'numeroSerie',
      'caracteristicas',
      'rubro',
      'rubroNombre',
      'cotizacion',
      'pjeAmortizacion',
      'enRevision'
    ])
  },  
  created() {
    let bienId = 0;

    if (!this.modal) {
      if (this.$route.params){
        if (this.$route.params.id){
          bienId = this.$route.params.id;
        }
      }
    }

    if (this.modal) {
      if (this.bienId) {
        if (this.bienId != 0) {
          bienId = this.bienId;
        }
      }
    }

    this.showSpinner();
    this.inicializando = true;
    this.$store.dispatch('computadora/inicializar', bienId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => {
        this.hideSpinner();
        this.inicializando = false;
      })
  },  
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('bienesRubros/getList')
      .then(() => {
          this.rubros = this.$store.getters['bienesRubros/list']
          this.rubrosList = this.$store.getters['bienesRubros/selectList']
        })
      .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de rubros.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'codigo' || validarTodos) {
        if (this.$v.codigo.$error) {
          this.codigoValido = false;
          if (!this.$v.codigo.required) {
            this.codigoInvalidoMsj= 'Debe ingresar el código identificatorio del equipo.';
          } else if (!this.$v.codigo.maxLength) {
            this.codigoInvalidoMsj = 'El código solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.codigoValido = null;
          this.codigoInvalidoMsj = '';
        }
      }

      if (campo == 'marcaModelo' || validarTodos) {
        if (this.$v.marcaModelo.$error) {
          this.marcaModeloValido = false;
          if (!this.$v.marcaModelo.required) {
            this.marcaModeloInvalidoMsj= 'Debe ingresar la marca/modelo del equipo.';
          } else if (!this.$v.marcaModelo.maxLength) {
            this.marcaModeloInvalidoMsj = 'La marca/modelo solo puede contener hasta 500 caracteres';
          } 
        } else {
          this.marcaModeloValido = null;
          this.marcaModeloInvalidoMsj = '';
        }
      }
        
      if (campo == 'numeroSerie' || validarTodos) {
        if (this.$v.numeroSerie.$error) {
          this.numeroSerieValido = false;
          if (!this.$v.numeroSerie.maxLength) {
            this.numeroSerieInvalidoMsj = 'El nro. de serie solo puede contener hasta 500 caracteres';
          } 
        } else {
          this.numeroSerieValido = null;
          this.numeroSerieInvalidoMsj = '';
        }
      }

      if (campo == 'caracteristicas' || validarTodos) {
        if (this.$v.caracteristicas.$error) {
          this.caracteristicasValidas = false;
          if (!this.$v.caracteristicas.maxLength) {
            this.caracteristicasInvalidasMsj = 'Las características solo pueden contener hasta 5000 caracteres';
          } 
        } else {
          this.caracteristicasValidas = null;
          this.caracteristicasInvalidasMsj = '';
        }
      }

      if (campo == 'cotizacion' || validarTodos) {
        if (this.$v.cotizacion.$error) {
          this.cotizacionValida = false;
          if (!this.$v.cotizacion.required) {
            this.cotizacionInvalidaMsj= 'Debe ingresar la cotización del equipo.';
          } else if (!this.$v.cotizacion.decimal || !this.$.cotizacion.minValue) {
            this.cotizacionInvalidaMsj = 'La cotización ingresada no es válida.';
          } 
        } else {
          this.cotizacionValida = null;
          this.cotizacionInvalidaMsj = '';
        }
      }

      if (campo == 'pjeAmortizacion' || validarTodos) {
        if (this.$v.pjeAmortizacion.$error) {
          this.pjeAmortizacionValido = false;
          if (!this.$v.pjeAmortizacion.decimal || !this.$.pjeAmortizacion.minValue) {
            this.pjeAmortizacionInvalidoMsj = 'El porcentaje de amortización ingresado no es válida.';
          } 
        } else {
          this.pjeAmortizacionValido = null;
          this.pjeAmortizacionInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let rubroError = true;
      if (this.rubro) {
        if (this.rubro.id) {
          if (this.rubro.id != 0) {
            rubroError = false;
          }
        }
      }
      if (rubroError) {
        save = Boolean(false);
        this.rubroValido = false;
        this.rubroInvalidoMsj = "Debe seleccionar el rubro correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('computadora/save')
            .then(()  => {
              if (!this.modal) {
                this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light');
              } else {
                this.$emit('updateBien', 
                  this.$store.getters['computadora/computadora']);
              }
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      } 
    },
    goBack() {
      if (!this.modal) {
        this.$router.go(-1);
      } else {
        this.$emit('closeBien');
      }
    },
    goList() {
      this.$router.push({ name: "Bienes" });
    },
    rubroActualizado(rubroNombre) {
      if (!this.inicializando) {
        let rubro = null;
        if (rubroNombre) {
          rubro = this.getSelected(this.rubros, rubroNombre);
        }
        this.$store.dispatch('computadora/setRubro', rubro);

        this.rubroValido = null;
        this.rubroInvalidoMsj = '';
      }
    },
  },
  watch: {
  },
  validations: {
    codigo: {
      required,
      maxLength: maxLength(50)
    },
    marcaModelo: {
      required,
      maxLength: maxLength(500)
    },
    numeroSerie: {
      maxLength: maxLength(500)
    },
    caracteristicas: {
      maxLength: maxLength(5000)
    },
    cotizacion: {
      required,
      decimal,
      minValue: minValue(0)
    },
    pjeAmortizacion: {
      decimal,
      minValue: minValue(0)
    },
  },  
}
</script>

<style>
</style>
